/**
 * © [2024] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import * as actionTypes from './ActionTypes';

const axiosPayLoad = {
  errorMessagesInRedux: [],
  reminderRecipeObj: {},
  saveOrUpdateMessage: {},
  reminderRecipientList: [],
  userList: [],
};

const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.HANDLE_ERROR_MESSAGE_RR:
      return {
        ...state,
        errorMessagesInRedux: action.errorMessagesInRedux,
      };
    case actionTypes.REMINDER_RECIPE_SCREEN_TAB_DATA:
      return {
        ...state,
        reminderRecipeObj: action.reminderRecipeObj,
      };
    case actionTypes.GET_REMINDER_RECIPIENT_LIST:
      return { ...state, reminderRecipientList: action.reminderRecipientList };
    case actionTypes.SAVE_OR_UPDATE_RR:
      return { ...state, saveOrUpdateMessage: action.saveOrUpdateMessage };
    case actionTypes.GET_REMINDER_USER_LIST:
      return { ...state, userList: action.userList };
    default:
      return state;
  }
};

export default reducer;
